import { gql, useQuery } from '@apollo/client';
import { useState } from 'react';

export const GET_CURRENT_EMPLOYEE_ABSENCES = gql`
  query getCurrentMemberAbsences($isAbsencesToApprove: Boolean!, $queryOptions: QueryOptionsInput) {
    getCurrentMemberAbsences(
      isAbsencesToApprove: $isAbsencesToApprove
      queryOptions: $queryOptions
    ) {
      collection {
        _id
        absenceReason {
          name
        }
        paymentType
        from
        to
        allDay
        approvalStatus
        details
        approver {
          profile {
            displayName
          }
        }
        member {
          profile {
            displayName
          }
        }
        createdByMember {
          profile {
            displayName
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetCurrentEmployeeAbsences = ({
  isAbsencesToApprove,
}: {
  isAbsencesToApprove: boolean;
}) => {
  const [currentPage, setPage] = useState(1);

  const pageSize = 12;
  const { data, loading } = useQuery(GET_CURRENT_EMPLOYEE_ABSENCES, {
    variables: {
      isAbsencesToApprove,
      filterQuery: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
      },
    },
    fetchPolicy: 'no-cache',
  });

  const memberAbsences = data?.getCurrentMemberAbsences.collection || [];

  return {
    memberAbsences,
    loading,
    paginationConfig: {
      total: data?.getCurrentMemberAbsences?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};
